<a
  href="{{ socialButton.url }}"
  class="club-social-button club-social-button-{{
    socialButton.type
  }} uk-text-truncate"
  target="_blank"
>
  {{ socialButton.type }}
</a>
